import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Row, RowBetween } from '../../../../style/basic/commonStyle'
import { addTheme } from '../../../../style/addTheme';
import BasicText from '../../../basic/BasicText';
import { numberWithComma } from '../../../../utils/format/number';
import { useAdminUser } from '../../../../utils/custom-hooks/common/useAdminUser';
import { apiAdmGetTotalCount } from '../../../../api/api_adm_login';

export default function AdminPageTotalPart({title,number,unit,children,part,reload}:any) {
    const adminUser = useAdminUser();
    const [count,setCount] = useState(0);

    useEffect(()=>{
        if(number !== undefined) return
        if(adminUser.admin_id === 0) return;
        if(part === '' || part === undefined) return;
        getCount();
    },[adminUser.admin_id,part,reload,number])

    const getCount = async() =>{
        const res = await apiAdmGetTotalCount(adminUser.admin_token,adminUser.admin_id,part);
        if(res.result){
            setCount(res.data.count);
        }
    }

    return (
        <Wrap>
            <TextWrap>
                <BasicText fontSize={20} fontWeight={700} mFontSize={18} color='#000'>{title}</BasicText>
                <BasicText fontSize={16} mFontSize={15} color='#1D4579'><span style={{fontWeight:700}}>{numberWithComma(number ?? count ?? 0)}</span>{unit ?? '건'}</BasicText>
            </TextWrap>
            <BtnWrap>
                {children}
            </BtnWrap>
        </Wrap>
    )
}

const Wrap = styled(RowBetween)`
    background-color: #fff;
    padding: 15px 20px;
    gap: 10px;
    border-radius: 15px;
    flex-wrap: wrap;
    min-height: 66px;
    @media ${addTheme.media.s}{
        padding: 10px;
    }
`;

const TextWrap = styled(Row)`
    gap: 20px;
    flex-wrap: wrap;
    width: auto;
`;

const BtnWrap = styled(Row)`
    gap: 8px;
    width: auto;
    flex-wrap: wrap;
`;